import { render } from "./red-basic.vue?vue&type=template&id=4239ee52&scoped=true"
import script from "./red-basic.vue?vue&type=script&lang=js"
export * from "./red-basic.vue?vue&type=script&lang=js"

import "./red-basic.vue?vue&type=style&index=0&id=4239ee52&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4239ee52"]])

export default __exports__